module.exports = __webpack_public_path__ + "img/IMG_3450_L.bf7dcc5c.webp";